"use client"

import type { ComponentProps, ReactNode } from "react"

import toast from "react-hot-toast"

import { RHFForm } from "#components/form/rhfFormContext"
import { useValidatedForm } from "#components/form/useValidatedForm"
import { artistApplyDto } from "#modules/contact/artist/basicArtistApplySection/artistApply.dto"
import { contactService } from "#modules/contact/contact.service"
import { useTranslation } from "#modules/localization/translations.client"

export function ArtistApplyForm({ children, ...restFormProps }: { children: ReactNode } & Omit<ComponentProps<typeof RHFForm>, "formMethods" | "children" | "validationSchema">) {
  const { t } = useTranslation("cp/basicArtistApplySection")

  const formMethods = useValidatedForm({
    validation: artistApplyDto,
    onSubmit: async data => {
      // TODO maybe send a name that is given via props to know from where the call was made
      if (fbq) fbq("track", "Lead", { content_name: "Artist Apply Form" })

      toast.loading(t("form.processingMessages.loading"))

      try {
        await contactService.basicArtistApplication(data)

        toast.dismiss()
        toast.success(t("form.processingMessages.success"))

        formMethods.reset()
      } catch (e) {
        toast.dismiss()
        toast.error(t("form.processingMessages.error"))
      }
    },
  })

  return (
    <RHFForm {...restFormProps} formMethods={formMethods}>
      {children}
    </RHFForm>
  )
}
